<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <md-section md="quick-start.md" />
      </flex-col>
      <flex-col :span="24">
        <flex>
          <flex-col :span="4" sm24 equal-height>
            <container :class="['p-1']">
              <btn block size="sm" color="white" icon-left="download" :color-lightness="null" :bg-color="$root.colors.primary" :bg-color-lightness="$root.colors.bgColorLightness" tag="a" :href="`${$root.config.staticAssetsDir}/downloads/bcq-ui-${$config.version}.zip`" :title="`${$lang.downloadBcqUi} ${$config.version}`">{{ $lang.downloadBcqUi }}</btn>
            </container>
          </flex-col>
          <flex-col :span="4" sm24 equal-height>
            <container :class="['p-1']">
              <btn block size="sm" color="white" icon-left="flag" :color-lightness="null" :bg-color="$root.colors.primary" :bg-color-lightness="$root.colors.bgColorLightness" tag="a" :href="`${$root.config.staticAssetsDir}/downloads/flags.zip`" :title="$lang.downloadFlags">{{ $lang.downloadFlags }}</btn>
            </container>
          </flex-col>
          <flex-col :span="4" sm24 equal-height>
            <container :class="['p-1']">
              <btn block size="sm" color="white" icon-left="qrcode" :color-lightness="null" :bg-color="$root.colors.primary" :bg-color-lightness="$root.colors.bgColorLightness" tag="a" :href="`${$root.config.staticAssetsDir}/downloads/qrcode.zip`" :title="$lang.downloadQrCode">{{ $lang.downloadQrCode }}</btn>
            </container>
          </flex-col>
          <flex-col :span="12" md24 />
        </flex>
      </flex-col>
    </flex>
    <all-section-blocks :title="true" :tooltip="false" />
  </container>
</template>
<script>
export default {
  name: 'PageQuickStart'
}
</script>



// WEBPACK FOOTER //
// src/pages/getting-started/quick-start.vue